var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreationCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 40,
    height: 40,
    rx: 16,
    fill: "#0061FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.157 13.8594H21.027C20.397 13.8594 19.887 14.3994 19.887 15.0694C19.887 15.7394 20.397 16.2794 21.027 16.2794H29.167C29.797 16.2794 30.307 15.7394 30.307 15.0694C30.307 14.3994 29.797 13.8594 29.167 13.8594H29.157Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1567 19.8008H17.1667C16.5367 19.8008 16.0267 20.3408 16.0267 21.0108C16.0267 21.6808 16.5367 22.2208 17.1667 22.2208H29.1567C29.7867 22.2208 30.2967 21.6808 30.2967 21.0108C30.2967 20.3408 29.7867 19.8008 29.1567 19.8008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1567 25.5898H12.8067C12.1767 25.5898 11.6667 26.1298 11.6667 26.7998C11.6667 27.4698 12.1767 28.0098 12.8067 28.0098H29.1567C29.7867 28.0098 30.2967 27.4698 30.2967 26.7998C30.2967 26.1298 29.7867 25.5898 29.1567 25.5898Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6467 13.8392L13.7967 12.1892C12.8467 11.6492 11.6667 12.3292 11.6667 13.4192V16.7092C11.6667 17.7992 12.8467 18.4892 13.7967 17.9392L16.6467 16.2992C17.5967 15.7492 17.5967 14.3892 16.6467 13.8392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationCard1);
export default __webpack_public_path__ + "static/media/creation-card-1.079e3511ea599082068953f2620276b7.svg";
export { ForwardRef as ReactComponent };